import {GenOutageBreakdown} from '../../../../../generated/serverModels/GenOutageBreakdown';
import {GenOutageType} from '../../../../../generated/serverModels/GenOutageType';

export class OutageBreakdown extends GenOutageBreakdown {
    public breakdownMap: Map<GenOutageType, number> = new Map<GenOutageType, number>();

    constructor(breakdown?: OutageBreakdown) {
        super(breakdown);

        if (breakdown) {
            this.outageBreakdowns.forEach((b) => {
                this.breakdownMap.set(b.outageType, b.outageCount);
            });
        }
    }
}
